import IDMGlobals from './../../IDMGlobals';
//
export default class APIUser {
  constructor(API) {
    this.api = API;
  }
  //Reads
  async searchUsersByIDs(ids) {
    const req = await this.api.newBaseRequest('POST');
    req.path = IDMGlobals.APIPath_UsersSearchByID;
    req.body = { userIDs: ids };
    return await req.exec();
  }
  async searchUsersByTerm(term, filter) {
    const req = await this.api.newBaseRequest('POST');
    req.path = IDMGlobals.APIPath_UsersSearch;
    req.body = { searchTerm: term, filter: (filter ? filter : {}) };
    return await req.exec();
  }
  async listAll() {
    const req = await this.api.newBaseRequest('GET');
    req.path = IDMGlobals.APIPath_Users;
    return await req.exec();
  }
  async read(userID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = IDMGlobals.APIPath_User + userID;
    return await req.exec();
  }
  async readByEmail(email) {
    const req = await this.api.newBaseRequest('GET');
    req.path = IDMGlobals.APIPath_UserEmail + email;
    return await req.exec();
  }
  //Updates
  async simpleUpdate(userObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = IDMGlobals.APIPath_User + userObj.id + IDMGlobals.APIPath_UserSimple;
    req.body = {...userObj};
    return await req.exec();
  }
  async update(userObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = IDMGlobals.APIPath_User + userObj.id;
    req.body = {...userObj};
    return await req.exec();
  }
  //Enable/Disable
  async enable(userID) {
    const req = await this.api.newBaseRequest('POST');
    req.path = IDMGlobals.APIPath_User + userID + IDMGlobals.APIPath_UserEnable;
    return await req.exec();
  }
  async disable(userID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = IDMGlobals.APIPath_User + userID + IDMGlobals.APIPath_UserDisable;
    return await req.exec();
  }
  //MFA
  async enableSMSMFA(userID) {
    const req = await this.api.newBaseRequest('POST');
    req.path = IDMGlobals.APIPath_User + userID + IDMGlobals.APIPath_SMSMFA;
    return await req.exec();
  }
  async disableSMSMFA(userID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = IDMGlobals.APIPath_User + userID + IDMGlobals.APIPath_SMSMFA;
    return await req.exec();
  }
  //Phone verification
  async verifyPhone(userID, phoneNumber) {
    const req = await this.api.newBaseRequest('POST');
    req.path = IDMGlobals.APIPath_User + userID + '/verifyPhone';
    req.body = { phoneNumber };
    return await req.exec();
  }
  async confirmPhoneVerification(userID, code) {
    const req = await this.api.newBaseRequest('POST');
    req.path = IDMGlobals.APIPath_User + userID + '/confirmPhone';
    req.body = { code };
    return await req.exec();
  }
}
